import { render, staticRenderFns } from "./SvgImageTypeModal.vue?vue&type=template&id=6da7c8e5&scoped=true"
import script from "./SvgImageTypeModal.vue?vue&type=script&lang=js"
export * from "./SvgImageTypeModal.vue?vue&type=script&lang=js"
import style0 from "./SvgImageTypeModal.vue?vue&type=style&index=0&id=6da7c8e5&scoped=true&lang=css"
import style1 from "./SvgImageTypeModal.vue?vue&type=style&index=1&id=6da7c8e5&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da7c8e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da7c8e5')) {
      api.createRecord('6da7c8e5', component.options)
    } else {
      api.reload('6da7c8e5', component.options)
    }
    module.hot.accept("./SvgImageTypeModal.vue?vue&type=template&id=6da7c8e5&scoped=true", function () {
      api.rerender('6da7c8e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SvgImageTypeModal.vue"
export default component.exports